module.exports = __webpack_public_path__ + "static/media/no-meal.057becdd.png";